// HeroPage.js
// Shows hero content and sign up/login options for unauthenticated users

import React from 'react';
import { Link } from 'react-router-dom';

function HeroPage() {
  return (
    <div className="hero-page">
      <img 
        src="/assets/black_logo.png" 
        alt="Kana Logo" 
        className="hero-logo"
      />
      <div className="hero-content">
        <h1 className="hero-title">Save 10 hours every week with Kana</h1>
        <p className="hero-description">
          Kana is an AI personal assistant, supervised by real humans.
        </p>
      </div>
      
      <div className="hero-actions">
        <Link to="/signup" className="button button-primary">
          Sign Up
        </Link>
        <Link to="/login" className="button button-secondary">
          Login
        </Link>
      </div>
    </div>
  );
}

export default HeroPage;
